import { Hidden } from '@mui/material'
import cn from 'classnames'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { Fragment } from 'react'
import StarSVG from 'src/assets/ic-four-star.png'
import { SHOW_ARTICLE_CAROUSEL } from 'src/config/config'

import { BannerContent } from './types'

export const HeroBanner = ({ title, externalLink, linkButtonLabel = 'Learn more' }: BannerContent) => {
  const router = useRouter()

  const handleClick = () => {
    if (externalLink) {
      window.open(`${externalLink}`, '_blank', 'noopener,noreferrer')
    } else {
      router.push('/')
    }
  }

  const Content = ({ compact = false }) => (
    <div
      className={cn(
        'flex w-full max-w-full items-center justify-center bg-lightRoyalBlue text-turquoise font-secondary text-center',
        compact
          ? 'px-4 py-2 gap-3 text-[0.95rem] leading-7 flex-wrap'
          : 'flex-row flex-nowrap whitespace-nowrap overflow-x-auto overflow-y-hidden min-w-full max-w-[55rem] text-[1.0rem] leading-[3rem] tracking-normal',
        SHOW_ARTICLE_CAROUSEL && !compact ? ' absolute left-0 bottom-0 ' : '',
      )}
    >
      {!compact && (
        <>
          <Image src={StarSVG} className="w-[30px] h-[25px]" width={30} height={25} alt="" />
          <span className="mx-5"></span>
        </>
      )}
      <span className={compact ? 'flex flex-wrap items-center justify-center gap-1' : ''}>
        {title} &nbsp;
        <button
          className={cn(
            'text-white underline underline-offset-[0.1rem] decoration-white decoration-solid decoration-[.1rem] cursor-pointer',
            compact ? 'text-[0.95rem] ml-0' : 'text-[1.0rem] ml-2',
          )}
          onClick={handleClick}
        >
          {linkButtonLabel}
        </button>
      </span>
      {!compact && (
        <>
          <span className="mx-5"></span>
          <Image src={StarSVG} className="w-[30px] h-[25px]" width={30} height={25} alt="" />
        </>
      )}
    </div>
  )

  if (!title) return null

  return (
    <Fragment>
      <Hidden lgDown>
        <Content />
      </Hidden>
      <Hidden lgUp>
        <div className="-mx-3">
          <Content compact />
        </div>
      </Hidden>
    </Fragment>
  )
}
